import { ChangeEventHandler } from 'react';
import * as React from 'react';

import cx from 'classnames';
import TextareaAutosize from 'react-textarea-autosize';
import { TextareaAutosizeProps } from 'react-textarea-autosize/dist/declarations/src';

export type Props = TextareaAutosizeProps & {
  withBorder?: boolean;
  autosize?: boolean;
  /** HTML ID for the element */
  id?: string;
  /** HTML name for the element */
  name?: string;
  /** onChange transparently passed to the input */
  onChange?: ChangeEventHandler<HTMLTextAreaElement>;
  /** Text to display when the input is empty */
  placeholder?: string;
  /** The default value for the field */
  defaultValue?: string;
  /** The current value for the field */
  value?: string;
  onFocus?: React.FocusEventHandler;
  onBlur?: React.FocusEventHandler;
  /** Native HTML pattern property, accepts a regular expression to validate the input */
  pattern?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  autoComplete?: string;
  autoCorrect?: string;
  spellCheck?: boolean;
  className?: string;
  noResize?: boolean;
};

export default React.forwardRef(function TextArea(
  {
    withBorder = true,
    autosize = true,
    className,
    disabled,
    minRows,
    noResize = false,
    ...props
  }: Props,
  ref: React.Ref<HTMLTextAreaElement>
) {
  const inputClass = cx(
    'px-3 py-2 m-0 font-sans text-base leading-8 border-0 rounded-2 outline-none appearance-none focus:shadow-focus',
    {
      'shadow-border': withBorder,
      'bg-grey-50': disabled,
      'resize-none': autosize || noResize,
      'resize-y': !autosize && !noResize,
      [className]: !!className,
    }
  );

  if (autosize) {
    return (
      <TextareaAutosize
        ref={ref}
        className={inputClass}
        {...props}
        minRows={minRows}
      />
    );
  } else {
    return (
      <textarea
        ref={ref}
        rows={minRows}
        className={inputClass}
        {...props}
      ></textarea>
    );
  }
});
